import EDHttp from '../utils/EDHttp';
import FileDownload from 'js-file-download';
import Auth from './auth';
import { getFileName } from '../utils/Formatter';

export default {
  async setRecertificationDate(userId, details) {
    
    try {
      const { data: result } = await EDHttp.post(`/recertification/${userId}/date`, details)
      return result.data;
    } catch (error) {
      throw error.response.data.message
    }
  },
  async deletePSLFRecertificationDate(userId) {
    try {
      const { data: result } = await EDHttp.delete(`/recertification/pslf-recertification/${userId}/date`);
      return result.data;
    } catch (error) {
      throw error.response.data.message
    }
  },
  async update(id, formId, status, isEmployerCurrent) {
    try {
      const query = isEmployerCurrent ? `?isEmployerCurrent=${isEmployerCurrent}` : '';
      const { data: result } = await EDHttp.put(`/api/forms/${id}/${formId}/${status}${query}`);
      return result.data;
    } catch (error) {
      throw error.response.data.message
    }

  },
  async mark(id, formId) {
    try {
      const { data: result } = await EDHttp.post(`/api/forms/complete/${id}/form/${formId}`)
      return result.data;
    } catch (error) {
      throw error.response.data.message
    }
  },
  async sign(id, formId) {
    try {
      const { data: result } = await EDHttp.get(`/api/forms/sign/${formId}/${id}`);
      return result.data;
    } catch (error) {
      throw error.response.data.message
    }
  },
  async faxLive(id, formId, faxWithTax = false) {
    try {
      const queryParams = faxWithTax ? "?faxWithTax=1" : ""
      const { data: result } = await EDHttp.post(`/api/forms/submit/fax/live/fax/${formId}/${id}${queryParams}`);
      return result.data;
    } catch (error) {
      throw error.response.data.message;
    }
  },
  async uploadSignedForm(id, formId, formData) {
    try {
      const { data: result } = await EDHttp.uploadFormData(`/api/forms/${formId}/${id}/${Auth.account.id}`, formData)
      return result.data;
    } catch (error) {
      throw error.response.data.message;
    }
  },
  async downloadSignedForm(id, formId, form, triggerDownload = true, fileName = null, fileId = null, isMultipleFile = false) {
    try {
      let fileExtension = isMultipleFile ? "zip" : "pdf";
      if (fileName) {
        fileExtension = isMultipleFile ? 'zip' : fileName.substring(fileName.lastIndexOf('.') + 1);
      }
      const response = await EDHttp.downloadSignedForm(id, formId, fileId, isMultipleFile)
      const file = getFileName(form, fileExtension)
      if (triggerDownload) {
        FileDownload(response.data, file);
      } else {
        return {
          data: response.data,
          file
        }
      }
    } catch (error) {
      throw error.response.data.message;
    }
  },
  async getMMPProofFile(mmpProof) {
    try {
      const fileExtension = mmpProof.substring(mmpProof.lastIndexOf('.') + 1)
      const response = await EDHttp.getMMPProofFile(mmpProof)
      const file = getFileName(mmpProof, fileExtension)
        return {
          data: response.data,
          file
        }
    } catch (error) {
      throw error.response.data.message;
    }
  },
  assignForm: async function (
    id,
    payload
  ) {
    try {
      const result = await EDHttp.post(`/api/forms/assign/form/manual/${id}`, payload)
      if (result && !result.data.error) {
        return result.data.data
      }
      throw result.data.error;
    } catch (error) {
      throw error.response.data.message;
    }
  },
  reAssignForm: async function (
    userId,
    formId
  ) {
    try {
      const result = await EDHttp.post(`/api/forms/reassign/${userId}/${formId}`)
      if (result && !result.data.error) {
        return result.data.data
      }
      throw result.data.error;
    } catch (error) {
      throw error.response.data.message;
    }
  },
  delete: async function (id) {
    try {
      const result = await EDHttp.delete(`/api/forms/delete-form/${id}`);
      if (result && !result.data.error) {
        return result
      }
      throw result.data.error
    } catch (error) {
      throw error
    }
  },
  deleteForm: function(id, formId, reason = '') {
    return new Promise((resolve, reject) => {
      EDHttp.post(`/api/forms/void/${formId}/${id}`, { reason })
        .then(
          result => {
            if (result && !result.data.error) resolve(result.data.data);
            else reject('Error');
          },
          error => reject(error)
        )
        .catch(error => reject(error));
    });
  },
  list: async function() {
    let result = await EDHttp.get(`/api/forms/custom/get/forms`)
    if (result && !result.data.error) {
      return result.data.data
    } else {
      return result.data.error
    }
  },
  add: function(form) {
    return new Promise((resolve, reject) => {
      EDHttp.post(`/api/forms/custom/create/forms`, form)
        .then(
          result => {
            if (result && !result.data.error) resolve(result.data.data);
            else reject('Error');
          },
          error => reject(error)
        )
        .catch(error => reject(error));
    });
  },
  updateCustomForm: function(id, form) {
    return new Promise((resolve, reject) => {
      EDHttp.put(`/api/forms/custom/forms/update/${id}`, form)
        .then(
          result => {
            if (result && !result.data.error) resolve(result.data.data);
            else reject('Error');
          },
          error => reject(error)
        )
        .catch(error => reject(error));
    });
  },
  get: function(form) {
    return new Promise((resolve, reject) => {
      EDHttp.get(`/api/forms/custom/forms/${form}`)
        .then(
          result => {
            if (result && !result.data.error) resolve(result.data.data);
            else reject('Error');
          },
          error => reject(error)
        )
        .catch(error => reject(error));
    });
  },
  async updateForm(userId, formId, payload) {
    try {
      const { data: result } = await EDHttp.put(`/api/forms/${formId}/${userId}`, payload);
      return result.data;
    } catch (error) {
      throw error.response.data.message;
    }
  },
};
